import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/pricing')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_public/pricing"!</div>
}
